import React, { useContext, useState, useEffect } from "react"; // Importing necessary React components and hooks.

import {
  AppBar, // Material-UI component for the application bar.
  Divider, // Material-UI component to create dividers.
  Fade, // Material-UI component for fading transitions.
  Toolbar, // Material-UI component for the toolbar.
  Typography, // Material-UI component for text.
} from "@material-ui/core";
import { IconButton } from "@material-ui/core"; // Material-UI component for IconButton.
import SwipeableDrawer from "@mui/material/SwipeableDrawer"; // Swipeable drawer component.
import { Box } from "@material-ui/core"; // Material-UI component for creating boxes.
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"; // Material-UI list components.
import { ListItemButton } from "@mui/material"; // Custom ListItem with button behavior.
import Menu from "@mui/material/Menu"; // Material-UI menu component.
import MenuItem from "@mui/material/MenuItem"; // Material-UI menu item component.
import Button from "@material-ui/core/Button"; // Material-UI button component.

import InfoIcon from "@mui/icons-material/Info";
import LogoPNG from "../Login/LogoPNG"; // Custom component for displaying a logo.
import MenuIcon from "@mui/icons-material/Menu"; // Material-UI icon component.
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AccessibilityNewIcon from "@mui/icons-material/AccessibilityNew";
import PeopleIcon from "@mui/icons-material/People";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined"; // Material-UI icon for workspaces.
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined"; // Material-UI icon for person.
import MedicationIcon from "@mui/icons-material/Medication";
import Avatar from "@material-ui/core/Avatar"; // Material-UI component for user avatars.
import AirlineSeatIndividualSuiteIcon from "@mui/icons-material/AirlineSeatIndividualSuite";
import FlatwareIcon from "@mui/icons-material/Flatware";

import { useNavigate } from "react-router-dom"; // React Router hook for navigation.
import { AuthContext } from "../../../context/AuthContext"; // Importing authentication context.
import { viewportContext } from "../../../context/ViewportContext";

import { getUserGroupById } from "../../../service/endpoint-manager"; // Importing a function for fetching user groups.

import styles from "../../../styles.module.css"; // Importing CSS module for styles.
import clsx from "clsx";
import { checkUserGroupAccess } from "../../../utils/helperFunctions";

const SideBarMenuList = [
  {
    title: "Hand Hygiene",
    path: "/handhygiene", // Path to Hand Hygiene
    icon: <CleanHandsIcon />, // Clean Hands icon for hand hygiene
  },
  {
    title: "PPE",
    path: "/ppe", // Path to PPE Audit
    icon: <AccessibilityNewIcon />, // Human/Clothes icon for PPE.
  },
  {
    title: "Patient",
    path: "/patient", // Path to Patients
    icon: <PersonOutlinedIcon />, // Person icon for PPE.
  },
  {
    title: "Narcotics",
    path: "/narcotics", // Path to Narcotics
    icon: <MedicationIcon />, // Person icon for Narcotics
  },
  {
    title: "Patient Care",
    path: "/patient-care",
    icon: <AirlineSeatIndividualSuiteIcon />,
  },
  {
    title: "Dining Audit",
    path: "/dining",
    icon: <FlatwareIcon />,
  },
];

const SideBarList = [
  {
    title: "Users",
    icon: <PeopleIcon />,
    path: "/users", // Path to Users page.
    adminOnly: true, // Accessible to non-admin users.
  },
  {
    title: "Group",
    icon: <WorkspacesOutlinedIcon />, // Workspaces icon for Group.
    path: "/userGroups", // Path to Group page.
    adminOnly: true, // Accessible to non-admin users.
  },
];

function Header(props) {
  const [open, setState] = useState(false); // State to manage drawer open/close.

  const navigate = useNavigate(); // React Router hook for navigation.
  const { errorAccessDenied } = useContext(AuthContext); // Accessing errorAccessDenied from the authentication context.
  const { screenType } = useContext(viewportContext);
  const [anchorEl, setAnchorEl] = React.useState(null); // State for anchor element of the avatar menu.
  const [focusedTab, setFocusedTab] = React.useState(SideBarList[0].path); // State to manage the currently focused sidebar tab.
  const [userGroup, setUserGroup] = useState(null); // State to store user group data.
  const openM = Boolean(anchorEl); // Check if the avatar menu is open.
  const [isLoading, setIsLoading] = useState(true); // State to indicate loading state.

  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let activityTimer;

    const handleActivity = () => {
      setIsActive(true);
      clearTimeout(activityTimer);
      activityTimer = setTimeout(() => setIsActive(false), 5000); // 5 seconds
    };

    const handleInactivity = () => {
      clearTimeout(activityTimer);
      setIsActive(false);
    };

    const handleMouseMove = () => {
      handleActivity();
    };

    const handleTouchMove = () => {
      handleActivity();
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("touchmove", handleTouchMove);

    const inactivityTimer = setTimeout(handleInactivity, 5000); // 5 seconds for initial inactivity

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("touchmove", handleTouchMove);
      clearTimeout(inactivityTimer);
      clearTimeout(activityTimer);
    };
  }, []);

  // Function to fetch and set the user group based on userGroup ID
  const getUserGroup = async (userGroupId) => {
    if (userGroupId) {
      const result = await getUserGroupById(userGroupId);
      setUserGroup(result?.data?.body);
    }
  };
  // Fetch user group and initialize focusedTab when the component mounts
  useEffect(() => {
    const userStorage = JSON.parse(localStorage.getItem("user-profile"));
    getUserGroup(userStorage.userGroup);
    var path = window.location.pathname;
    setFocusedTab(path);
  }, []);

  // Update isLoading state when userGroup changes
  useEffect(() => {
    setIsLoading(false);
  }, [userGroup !== null]);

  // Handle opening the avatar menu
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  // Handle closing the avatar menu
  const handleClose = () => {
    setAnchorEl(null);
  };
  // Handle navigation to the user profile page
  const handleProfile = () => {
    setAnchorEl(null);
    navigate("/profile");
  };
  // Destructure the logout function from the AuthContext
  const { logout } = useContext(AuthContext);
  // Handle user logout
  const handleLogout = () => {
    logout();
  };

  /*
  Function that is being called every time the drawer should open or close.
  Excludes the Tab and Shift keys to allow user focus between elements.
  */
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  // Function to check if a user has permissions for a module
  const hasModulePermissions = (module, action) => {
    return userGroup?.[module]?.[action] === true;
  };

  // Define the default paths for Hand Hygiene and PPE
  let handHygienePath = "/handhygiene";
  let ppePath = "/ppe";

  // Check if the user has permissions for Hand Hygiene Dashboard
  if (hasModulePermissions("handHygieneModule", "handHygieneDashboard")) {
    handHygienePath = "/HHanalytics";
  }

  // Check if the user has permissions for PPE Dashboard
  if (hasModulePermissions("ppeModule", "ppeDashboard")) {
    ppePath = "/PPEanalytics";
  }
  // Function to render the sidebar list
  const list = (anchor) => (
    <Box
      sx={{ width: anchor === "top" || anchor === "bottom" ? "auto" : 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List className={styles.tabList}>
        {SideBarMenuList.map((data, index) => (
          <>
            {checkUserGroupAccess(userGroup, data.title) ? (
              <ListItem key={data.title}>
                <ListItemButton
                  onClick={() => {
                    if (data.title === "Patient") {
                      setFocusedTab(data.path);
                      navigate("/patient");
                    } else if (data.title === "Narcotics") {
                      setFocusedTab(data.path);
                      navigate("/narcotics");
                    } else if (data.title === "Patient Care") {
                      setFocusedTab(data.path);
                      navigate("/patient-care");
                    } else if (data.title === "Dining Audit") {
                      setFocusedTab(data.path);
                      navigate("/dining");
                    } else {
                      setFocusedTab(data.path);
                      navigate(
                        data.title === "Hand Hygiene"
                          ? handHygienePath
                          : ppePath
                      );
                    }
                  }}
                >
                  <ListItemIcon
                    className={
                      focusedTab === data.path
                        ? styles.tabColorFocused
                        : styles.tabColorDefault
                    }
                  >
                    {data.icon}
                  </ListItemIcon>
                  <ListItemText
                    className={
                      focusedTab === data.path
                        ? styles.tabColorFocused
                        : styles.tabColorDefault
                    }
                    primary={
                      <Typography variant="body1">{data.title}</Typography>
                    }
                  />
                </ListItemButton>
              </ListItem>
            ) : (
              <></>
            )}
          </>
        ))}
      </List>

      {/* Render another list */}
      {userGroup?.isAdmin && (
        <List className={styles.adminTabList}>
          <div style={{ marginLeft: "1.6rem" }} className="adminListTitle">
            Admin
          </div>
          {SideBarList.map((data, index) => (
            <>
              {/* Render a list item if it matches certain conditions */}
              {data.adminOnly === userGroup?.isAdmin ||
              (!data.adminOnly && data.type !== "section") ? (
                <ListItem key={data.title}>
                  <ListItemButton
                    onClick={() => {
                      setFocusedTab(data.path);
                      navigate(`${data.path}`);
                    }}
                  >
                    <ListItemIcon
                      className={
                        focusedTab === data.path
                          ? styles.adminTabColorFocused
                          : styles.adminTabColorDefault
                      }
                    >
                      {data.icon}
                    </ListItemIcon>
                    <ListItemText
                      className={
                        focusedTab === data.path
                          ? styles.adminTabColorFocused
                          : styles.adminTabColorDefault
                      }
                      primary={
                        <Typography variant="body1">{data.title}</Typography>
                      }
                    />
                  </ListItemButton>
                </ListItem>
              ) : (
                <></>
              )}
            </>
          ))}
        </List>
      )}
    </Box>
  );

  const [headerAvatar, setHeaderAvatar] = useState(null);
  // Update the headerAvatar state when the component mounts
  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user-profile"));
    setHeaderAvatar(userProfile?.profilePic);
  });
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <header
      style={{
        marginBottom: errorAccessDenied?.status
          ? ""
          : isActive
          ? "5rem"
          : ".5rem",
      }}
    >
      <AppBar
        className={styles.topZIndex}
        style={{ display: isActive ? "flex" : "none" }}
        // style={isActive ? { display: "none" } : { display: "none" }}
      >
        <Toolbar>
          <div style={{ position: "absolute", left: "2rem" }}>
            <IconButton
              edge="start"
              aria-label="open drawer"
              onClick={props.toggleSidebar}
              sx={{
                mr: 2,
                display: {
                  xs: "block",
                  sm: "none",
                },
              }}
              style={{ color: "white" }}
            >
              {props.openSidebar ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>

            <SwipeableDrawer
              anchor="left"
              open={props.openSidebar}
              onOpen={props.toggleSidebar}
              onClose={props.toggleSidebar}
              BackdropProps={{ invisible: true }}
            >
              {list("left")}
            </SwipeableDrawer>

            <span style={{ marginLeft: "10px" }}>
              <LogoPNG
                style={{
                  width: "100px",
                  height: "20px",
                  verticalAlign: "middle",
                }}
              />
            </span>
          </div>

          <div className={styles.profileLogoutContainer}>
            <IconButton onClick={() => openInNewTab("https://auditsx.com")}>
              <InfoIcon style={{ color: "white" }} />
            </IconButton>
            <div>
              <IconButton onClick={handleClick}>
                <Avatar
                  src={
                    headerAvatar ||
                    "https://www.w3schools.com/howto/img_avatar.png"
                  }
                />
              </IconButton>

              <Box>
                <Menu
                  anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                  TransitionComponent={Fade}
                  anchorEl={anchorEl}
                  open={openM}
                  onClose={handleClose}
                >
                  <MenuItem onClick={handleProfile}>Profile</MenuItem>
                </Menu>
              </Box>
            </div>
            {screenType.isMobile ? (
              <></>
            ) : (
              <Divider
                className={styles.headerDividerStyles}
                orientation="vertical"
              />
            )}
            {/* Content after the divider */}
            <div className={styles.logoutContainer}>
              {screenType.isMobile ? (
                <>
                  <IconButton
                    className={clsx(`${styles.logoutMobile}`)}
                    onClick={handleLogout}
                  >
                    <PowerSettingsNewIcon />
                  </IconButton>
                </>
              ) : (
                <Button
                  className={clsx(
                    `${styles.logoutRedButton} ${styles.logoutDesktop}`
                  )}
                  onClick={handleLogout}
                  style={{}}
                >
                  {" "}
                  Logout
                </Button>
              )}
            </div>
          </div>
        </Toolbar>
      </AppBar>
    </header>
  );
}

export default Header;
